<script lang="ts">
    import { _ } from "svelte-i18n";
    import { appManager } from "../../AppManager";
    import { ModalHook } from "./ModalHook";

    let hook: ModalHook<string, boolean> = new ModalHook<string, boolean>();
    appManager.ModalHooks.DeleteConfirmModal = hook;
    let data: string = "";
    let open: boolean = false;

    // hook events.
    hook.on("open", () => {
        open = true;

        data = hook.getData();
    });
    hook.on("close", () => {
        open = false;
    });

    const ok = () => {
        hook.close(true);
    };

    const close = () => {
        hook.close(false);
    };
</script>

{#if open}
    <div
        class="modal show"
        style="display: block;"
        tabindex="-1"
        role="dialog"
        aria-labelledby="Label"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-body p-6">
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        on:click={close} />

                    <h4 class="font-weight-bold text-center mb-3">
                        {$_("modals.deleteconfirm.title")}
                    </h4>

                    <p class="font-size-lg text-center mb-6 mb-md-8">
                        {data}
                    </p>

                    <div class="row">
                        <div class="col-6">
                            <div class="d-grid gap-2">
                                <button
                                    class="btn btn-block btn-primary-desat-soft mt-3 lift"
                                    on:click={ok}>
                                    {$_("modals.deleteconfirm.ok")}
                                </button>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="d-grid gap-2">
                                <button
                                    class="btn btn-block btn-secondary-desat-soft mt-3 lift"
                                    on:click={close}>
                                    {$_("modals.deleteconfirm.cancel")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}
